import React, {Component} from "react";
import {Card} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";
import {ViewUserId, EditUserName, EditMailAddress, ViewPassword, SelectPermission,
    SelectDevice, EditTelNum, EditExternalNum, ViewType, ViewDefaultVoicesExpire
} from "../Elements/AscElements/UserElements";

export default class UserInsertModal extends Component {

    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                modalClose={this.props.modalClose}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}
                downloadFlag={true}
            >
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.UserInfo}
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <ViewUserId
                            state={this.props.state}
                            langText={this.props.langText}
                        />
                        <ViewPassword
                            state={this.props.state}
                            langText={this.props.langText}
                        />
                        <EditUserName
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange_Limit = {this.props.onTextChange_Limit}
                            charaLimit = {this.props.charaLimit}
                        />
                        <ViewType
                            state={this.props.state}
                            langText={this.props.langText}
                            onSelectChange={this.props.onSelectChange}
                        />
                        <ViewDefaultVoicesExpire
                            state={this.props.state}
                            langText={this.props.langText}
                        />
                        <EditMailAddress
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange_Limit = {this.props.onTextChange_Limit}
                            charaLimit = {this.props.charaLimit}
                            validateMail = {this.props.validateMail}
                        />
                        <EditTelNum
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange_Limit = {this.props.onTextChange_Limit}
                            charaLimit = {this.props.charaLimit}
                            validateTelNumber = {this.props.validateTelNumber}
                        />
                        <EditExternalNum
                            state={this.props.state}
                            langText={this.props.langText}
                            onMultiSelectChange_External={this.props.onMultiSelectChange_External}
                        />
                        <SelectPermission
                            state={this.props.state}
                            langText={this.props.langText}
                            onSelectChange={this.props.onSelectChange}
                        />
                        <SelectDevice
                            state={this.props.state}
                            langText={this.props.langText}
                            onMultiSelectChange={this.props.onMultiSelectChange}
                        />
                        {/* Issue #328: RecAceApp（Anywhere連携）は編集でのみ有効化する設計のため、
                            新規登録画面ではオプションのチェックボックス（SelectOptions）を表示しない。
                            aspire の既定ON は User.js の state 初期化で行われるため影響なし。 */}
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}
